export enum ENVIRONMENT {
  LOCAL = 'local',
  DEV = 'dev',
  UAT = 'uat',
  PROD = 'production',
}

export interface EnvConfig {
  ApiServer: {
    BaseURL: string;
  };
  API_VERSION: string;
  CONFIG_FILE: ENVIRONMENT;
  Environment: {
    Env: string;
  };
  IdentityServer: {
    BaseURL: string;
  };
  iframeUrl: string;
  iframeCourtUrl: string;
  iframeLogoutUrl: string;
  filingUrl: string;
  MAX_FILE_SIZE: number;
  production: boolean;
  /** When true, multi-case search uses mock results instead of the API. Disabled in UAT/prod. */
  useMockCaseSelectionResults: boolean;
  /** When true, multi-case sending parties uses mock caseparticipants instead of the API. Disabled in UAT/prod. */
  useMockMultiCaseSendingParties: boolean;
  /** When true, multi-case service list uses mock caseparticipants instead of the API. Disabled in UAT/prod. */
  useMockMultiCaseServiceList: boolean;
  /** When true, Clerk Review offers mock escalation queues until the escalation API exists. Disabled in UAT/prod. */
  useMockEscalationQueues: boolean;
  /**
   * When true, Case & Party Management (courts, actions, attorney types and the
   * Substitute Attorney calls) uses delayed mock data instead of the API. Disabled in UAT/prod.
   */
  useMockCaseManagement: boolean;
  /**
   * When true, bootstrap uses `provideZonelessChangeDetection` for local/dev/UAT soak.
   * Ignored in production — prod always stays Zone until soak passes. Compile-time only
   * (`environment.*.ts`); runtime `assets/config` cannot change CD providers.
   */
  useZonelessChangeDetection?: boolean;
}
